import { render, staticRenderFns } from "./AiSetupSummary.vue?vue&type=template&id=bcdf1eae&scoped=true"
import script from "./AiSetupSummary.vue?vue&type=script&lang=js"
export * from "./AiSetupSummary.vue?vue&type=script&lang=js"
import style0 from "./AiSetupSummary.vue?vue&type=style&index=0&id=bcdf1eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdf1eae",
  null
  
)

export default component.exports